import type { SVGProps } from "react";

export default function SolarCaseRoundLinear(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth={1.5}>
        <path d="M3 12c0 3.771 0 7.657 1.318 8.828C5.636 22 7.757 22 12 22s6.364 0 7.682-1.172C21 19.657 21 15.771 21 12" />
        <path d="m14.66 14.202l6.198-1.86c.411-.123.616-.185.768-.307a1.5 1.5 0 0 0 .3-.403C22 11.451 22 11.237 22 10.808c0-1.688 0-2.531-.33-3.175a3 3 0 0 0-1.303-1.303C19.723 6 18.88 6 17.192 6H6.808c-1.688 0-2.531 0-3.175.33a3 3 0 0 0-1.303 1.303C2 8.277 2 9.12 2 10.808c0 .429 0 .643.073.824a1.5 1.5 0 0 0 .3.403c.153.122.358.184.77.307l6.197 1.86" />
        <path strokeLinecap="round" d="M14 12.5h-4a.5.5 0 0 0-.5.5v2.162a.5.5 0 0 0 .314.464l.7.28a4 4 0 0 0 2.972 0l.7-.28a.5.5 0 0 0 .314-.464V13a.5.5 0 0 0-.5-.5Z" />
        <path strokeLinecap="round" d="M9.171 4A3 3 0 0 1 12 2a3 3 0 0 1 2.829 2" />
      </g>
    </svg>
  );
}
